export const getApplicationVersion = (environment: string, tag: string): string => {

  if (!tag) {

    return '';
  
  }

  if (!environment) {

    return tag;
  
  }

  return `${environment}-${tag}`;

};